import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as LimitMEdit } from '../../../../assets/limit_m_edit.svg'
import { FormControl, InputAdornment, Menu } from '@mui/material'
import { ButtonSaveStyleLimitM, OutlinedInputStyleLimitM } from '../ClientMmDetails.style'

const LimitMMenu = ({ limitM, setForm }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [limitMState, setLimitMState] = useState(limitM)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
    setLimitMState(limitM)
  }

  const handelChange = event => {
    setLimitMState(event.target.value)
  }

  const handelSubmit = async () => {
    setForm(prev => ({ ...prev, limit_m: limitMState }))
    handleClose()
  }

  const disabled = () => {
    return (
      limitM === limitMState ||
      limitMState === '' ||
      Number(limitMState) === 0 ||
      Number(limitMState) < 0 ||
      isNaN(limitMState)
    )
  }

  return (
    <>
      <LimitMEdit
        style={{ marginLeft: '22px' }}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      ></LimitMEdit>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        style={{
          padding: '24px'
        }}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          background: '#242428',
          boxShadow: '-2px 2px 4px 1px rgba(0, 0, 0, 0.50)',
          borderRadius: '8px'
        }}
      >
        <FormControl
          sx={{ m: 1, width: '114px' }}
          variant="outlined"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <OutlinedInputStyleLimitM
            id="outlined-adornment-password"
            type="text"
            value={limitMState}
            onChange={handelChange}
            endAdornment={<InputAdornment position="end">m</InputAdornment>}
            startAdornment={<InputAdornment position="start">$</InputAdornment>}
          />
          <ButtonSaveStyleLimitM onClick={handelSubmit} disabled={disabled()}>
            OK
          </ButtonSaveStyleLimitM>
        </FormControl>
      </Menu>
    </>
  )
}

export default LimitMMenu

LimitMMenu.propTypes = {
  limitM: PropTypes.string,
  setForm: PropTypes.func
}
